module.exports = __webpack_public_path__ + "img/map_bg_02.18d5c2f4.jpg";